import type { CityDefinition } from './types';

/**
 * Central registry for Calvino's Invisible Cities.
 * Designed so additional cities (e.g. Diomira, Zaira, Dorothea, Zobeide...)
 * can be registered without modifying core rendering or UI logic.
 */
class CityRegistryStore {
  private cities = new Map<string, CityDefinition>();

  register(city: CityDefinition): void {
    this.cities.set(city.id, city);
  }

  get(id: string): CityDefinition | undefined {
    return this.cities.get(id);
  }

  getDefault(): CityDefinition {
    const first = this.cities.values().next().value;
    if (!first) {
      throw new Error('CityRegistry has no registered cities.');
    }
    return first;
  }

  list(): CityDefinition[] {
    return Array.from(this.cities.values());
  }
}

export const cityRegistry = new CityRegistryStore();
